import { render, staticRenderFns } from "./SettingsTable.vue?vue&type=template&id=4aaa2a2e&scoped=true&"
import script from "./SettingsTable.vue?vue&type=script&lang=js&"
export * from "./SettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa2a2e",
  null
  
)

export default component.exports